import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Documents } from '../../commons/class/archivo.inteface';
import { DemandCommand } from '../../commons/class/demand.class';
import { ENV_TOKEN } from '../../app-module.token';

@Injectable({
  providedIn: 'root'
})
export class ElectronicDemandService {
  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;
  readonly environment = inject(ENV_TOKEN);
  private httpService: HttpService = inject(HttpService);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Elimina documentos de la pantalla
   * @param idDocument 
   * @returns 
   */
  EliminarDocumentosPantalla(idDocument: number): Observable<any> {
    const funcion = "icoij/DeleteDocumento";
    const ruta = `${this.urlRaiz}/${funcion}/${idDocument}`;
    return this.httpService.deleteRequest(ruta);
  }

  /**
   * Obtiene documentos de la pantalla por GUID, se construye la ruta para la consulta utilizando el GUID, se hace una petición GET al servicio utilizando la ruta construida, se procesa la respuesta para extraer los documentos y se retorna un Observable con el arreglo de documentos
   * @param uuid 
   * @returns 
   */
  getDocumentosPantallaGuid(uuid: string): any {
    const funcion = "icoij/getDocumentosByGuid";
    const ruta = `${this.urlRaiz}/${funcion}/${uuid}`;
    return this.httpService.getRequest(ruta).pipe(map((data: any) => (data.data as any[]).map((item: Documents) => {
      const model = new Documents();
      model.id = String(item.id);
      model.guid = item.guid;
      model.idOJ = item.idOJ;
      model.nombreOriginal = item.nombreOriginal;
      model.nombreSistema = item.nombreSistema;
      model.estatus = item.estatus;
      model.firmado = item.firmado;
      model.extension = item.extension;
      model.tamanio = item.tamanio;
      model.fecAlta = item.fecAlta;
      model.nombreReal = item.nombreReal;
      model.idDocumentoMdw = item.idDocumentoMdw;
      model.idTransaction = item.idTransaction;
      return model;
    })));

  }

  /**
   * Envía una demanda electrónica, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  EnvioDemanda(request: DemandCommand) {
    const funcion = "icoij/SendDemandElectronic";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Obtiene el acuse de una demanda electrónica, se construye la ruta para la consulta utilizando el ID de la demanda, se hace una petición GET al servicio utilizando la ruta construida, se retorna la respuesta del servicio
   * @param idDemanda 
   * @returns 
   */
  GetAcuseDemand(idDemanda: number) {
    const funcion = "icoij/getAcuseDemandElect";
    const ruta = `${this.urlRaiz}/${funcion}/${idDemanda}`;
    return this.httpService.getRequest(ruta)
  }


  /**
   * Obtiene la fecha en formato UTC para una fecha dada, se formatea la fecha en el formato requerido por el servicio utilizando los componentes de la fecha (año, mes, día, hora, minuto, segundo) y se retorna la cadena resultante
   * @param fecha 
   * @returns 
   */
  getStringDateUSTime(fecha: Date): string {

    let returnDate = "";
    const dd = fecha.getDate();
    const mm = fecha.getMonth() + 1; //because January is 0! 
    const yyyy = fecha.getFullYear();
    // var time=fecha.toLocaleTimeString();

    returnDate += `${yyyy}-`;

    if (mm < 10) {
      returnDate += `0${mm}-`;
    } else {
      returnDate += `${mm}-`;
    }

    if (dd < 10) {
      returnDate += `0${dd}T`;
    } else {
      returnDate += `${dd}T`;
    }


    const currentHour = fecha.getHours();
    const currentMinute = fecha.getMinutes();
    const currentSecond = fecha.getSeconds();

    if (currentHour < 10) {
      returnDate += `0${currentHour}:`;
    } else {
      returnDate += `${currentHour}:`;
    }

    if (currentMinute < 10) {
      returnDate += `0${currentMinute}:`;
    } else {
      returnDate += `${currentMinute}:`;
    }

    if (currentSecond < 10) {
      returnDate += `0${currentSecond}`;
    } else {
      returnDate += `${currentSecond}`;
    }



    return returnDate;
  }

    updateStatusSign(payload: any): Observable<any> {
      const funcion = "icoij/UpdateFirma";
      const ruta = `${this.urlRaiz}/${funcion}`;
      return this.httpService.putRequest(ruta, payload);
    }

   
}